import z from 'zod';

const diacriticsRegex = /[ĂăÂâÎîȘșȚț]/;
const noDiacritics = (value) => !value || !diacriticsRegex.test(value);
const diacriticsMessage = 'Diacritics are not allowed (Ă, Â, Î, Ș, Ț)';

export const projectFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: 'Project name is required' })
    .max(50, { message: 'Project name is too long' })
    .refine(noDiacritics, { message: diacriticsMessage }),
  clientId: z.number(),
  address: z.string().trim().optional().refine(noDiacritics, { message: diacriticsMessage }),
  notes: z.string().trim().optional().refine(noDiacritics, { message: diacriticsMessage }),
  discount: z.coerce.number(),
  hourlyRate: z.coerce.number(),
  hourlyCost: z.coerce.number(),
  transportCost: z.coerce.number({
    invalid_type_error: 'Transport cost is required',
    required_error: 'Transport cost is required'
  }),
  notifyClientOnStatusChange: z.boolean()
});
